export const getCountryKey = (country: string): string => (country?.includes('-') ? country?.split('-')[1] : country);
